import { ShoppingCart } from "lucide-react"
import { Link } from "react-router-dom"
import { useCart } from "../../context/cart-context"

export default function CartIcon() {
  const { totalItems } = useCart()

  return (
    <Link to="/cart" className="relative p-2">
      <ShoppingCart className="h-6 w-6 text-gray-700" />
      {totalItems > 0 && (
        <span className="absolute -top-1 -right-1 bg-[#ff9906] text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
          {totalItems > 99 ? "99+" : totalItems}
        </span>
      )}
    </Link>
  )
}